import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  themeType: -1

}
const themeTypeReducer = {
  changeTheme: (state, action) => {
    state.themeType = action.payload
  },
}


const themeSlice = createSlice({
  name: 'themeSlice',
  initialState: initialState,
  reducers: themeTypeReducer
});


export const themeSliceActions = themeSlice.actions
export default themeSlice.reducer
